import React from "react";

// Komponen untuk menampilkan tabel
const UserTableKab = ({ data }) => {
  return (
    <div style={{ backgroundColor: "#f0f0f0", padding: "10px", borderRadius: "5px", lineHeight: "1.5" }}>
      <table style={{ width: "100%", borderCollapse: "collapse", marginTop: "20px" }}>
        <thead>
          <tr style={{ background: "#e9d6d7", textAlign: "left" }}>
            <th style={{ padding: "8px" }}>Kabupaten</th>
            <th style={{ padding: "8px" }}>Provinsi</th>
            <th style={{ padding: "8px" }}>Persentase</th>
          </tr>
        </thead>
        <tbody>
          {data.map((user) => (
            <tr key={user.id}>
              <td style={{ padding: "8px" }}>{user.nama_kabupaten}</td>
              <td style={{ padding: "8px" }}>{user.nama_provinsi}</td>
              <td style={{ padding: "8px" }}>{user.total}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default UserTableKab;
